import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import { IconButton } from '@jutro/components';
import { MetadataContent } from '@jutro/uiconfig';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import _, { forEach, isEmpty, words } from 'lodash';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { NotificationService } from 'gw-capability-ri-policy-admin';
import { PolicyService } from 'gw-capability-policy';
import { useAuthentication } from 'gw-digital-auth-react';
import NotificationList from '../../Components/NotificationList/NotificationList';
import metadata from './MyNotifications.metadata.json5';
import styles from './MyNotifications.module.scss';
import notificationMessages from '../../Notification.messages';

function MyNotifications() {
    const { authHeader, authUserData } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const [refreshList, setRefreshList] = useState(0);
    const [accountBillingData, setAccountBillingData] = useState([]);
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    const [billingNumber, setBillingNumber] = useState(undefined);
    const [policyNumber, setPolicyNumber] = useState(undefined);
    const [subscriptions, setSubscriptions] = useState(undefined);
    const [pcSubscriptions, setPcSubscriptions] = useState(undefined);
    const [categoryValues, setCategoryValues] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubscription, setSelectedSubscription] = useState({});
    const [subscriptionForm, setSubscriptionForm] = useState({});   
    const [BillingAccountValues, setBillingAccountValues] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState([]);
    const [addMessage, setAddMessage] = useState('');
    const [hasError, setHasError] = useState({});
    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const [initSelectedAccount, setInitSelectedAccount] = useState([]); // FB 17882
    const [notifications, setNotifications] = useState([]);
    // FB 21479 --------
    const [showAddNotification, setShowAddNotification] = useState(false);
    const [channelTypeValues, setChannelTypeValues] = useState([]);
    const [selectedChannelType, setSelectedChannelType] = useState(''); 
    const [pcSubscriptionsSave, setPcSubscriptionsSave] = useState(undefined);
    const [pcSubscriptionObj, setPcSubscriptionObj] = useState(undefined);
    const [isValidEmail, SetIsValidEmail] = useState(true);
    const [isEditing, SetIsEditing] = useState(false);
    // -------- FB 21479
    
    useEffect(() => {
        setLoadingState(true);
        getAllSubscriptions();
        Promise.all(
            [
                PolicyService.getAccountPolicySummaries(authHeader).then(setAccountPolicyData)
            ]
        ).finally(() => {
            setLoadingState(false);
        });
        // Disabling to prevent continues re-rendering
        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [authHeader]);

    useEffect(() => {
        if (!_.isNull(accountPolicyData) && (!_.isEmpty(accountPolicyData))) {
            initBasicPolicyData();
            if (policyNumber) {
                getAllPCSubscriptions(policyNumber);
            }
        }
    }, [accountPolicyData, policyNumber]);

    useEffect(() => {
        // sort by descending
        accountBillingData.sort((a, b) => {
            if (a.policyEffectiveDate < b.policyEffectiveDate) return 1;
            if (a.policyEffectiveDate > b.policyEffectiveDate) return -1;
            return 0;
        });
        if (!_.isNull(accountBillingData) && (!_.isEmpty(accountBillingData))) {
            const billingIds = [];
            let count = 0;
            accountBillingData.forEach((sub) => {
                if (!(count >= 3)) {
                    billingIds.push(
                        {
                            code: sub.accountNumber,
                            name: `${sub.accountNumber} - Policy # ${sub.policyNumber} (${intl.formatDate(new Date(sub.policyEffectiveDate), { year: 'numeric', month: 'short', day: 'numeric' })})`
                        }
                    );
                }
                count++;
            });
            setBillingAccountValues(billingIds);
            // FB 17882 ---
            const billingIdsValues = billingIds.map(billing => {
                return billing.code;
            })            
            setSelectedAccount(billingIdsValues);
            setInitSelectedAccount(billingIdsValues);
            // --- FB 17882
        }
    }, [accountBillingData]);

    useEffect(() => {        

        if(pcSubscriptionObj !== undefined){
            setLoadingState(true);
            const pcnotificationPromise = NotificationService.updatePCSubscription(pcSubscriptionObj, authHeader);
            
            return pcnotificationPromise
            .then((responseData) => {
                console.log(`NotificationService.updatePCSubscription succsess! responseData = ${JSON.stringify(responseData)}`);                
            })
            .catch(() => {
                console.log(`NotificationService.updatePCSubscription Update Error`);
            })            
            .finally(() => {
                setLoadingState(false);
                setPcSubscriptionObj(undefined);
            });
        }
    },[pcSubscriptionObj,authHeader]);

    const initBasicPolicyData = () => {
        if (!_.isEmpty(accountPolicyData)) {
            accountPolicyData.find((policyData) => {
                policyData.periods.find((period) => {
                    if (period.billingIdExt) {
                        setBillingNumber(period.billingIdExt);
                        setPolicyNumber(period.policyId);
                        PolicyService.getPolicyBillingTermsExt(period.policyId, authHeader).then(setAccountBillingData);
                    }
                });
            });
        }
    };

    const getAllPCSubscriptions = useCallback(
        (policyNumber) => {
            setLoadingState(true);
            const pcnotificationPromise = NotificationService.getSubscriptionsByPolicy(policyNumber, authHeader);
            const notificationSelect = [];
            return pcnotificationPromise
                .then((responseData) => {                    
                    setPcSubscriptions(responseData);
                    setPcSubscriptionsSave(responseData);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [authHeader]
    );

    const getAllSubscriptions = useCallback(
        () => {
            setLoadingState(true);
            const notificationPromise = NotificationService.getAllSubscriptions(authHeader);
            const notificationSelect = [];
            return notificationPromise
                .then((responseData) => {
                    const data = responseData;
                    data.forEach((sub) => {
                        if (!(sub.subscriptionId === 'InsuredPolicyDocument')
                        && !(sub.subscriptionId === 'PaperlessBilling')
                        && !(sub.subscriptionId === 'SubmissionFollowUpMessage')
                        && !(sub.subscriptionId === 'PolicyDocument')
                            && !(sub.subscriptionId === 'ClaimsFNOL')) {
                            // filter GA Subscritions
                            notificationSelect.push(
                                {
                                    code: sub.subscriptionId,
                                    name: sub.name
                                }
                            );
                        }
                    });
                    setCategoryValues(notificationSelect);
                    setSubscriptions(responseData);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [authHeader]
    );

    const getUserName = useCallback(() => {
        let userName = ''; // oob
        if (!_.isUndefined(authUserData)) {
            userName = authUserData.userID;
        }
        return userName;
    }, [authHeader]);

    const checkEmailValidity = (email) => {
        const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
        return EMAIL_REGEX.test(email);
    };

    const checkPhoneValidity = (phone) => {
        const PHONE_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        return PHONE_REGEX.test(phone);
    };

    const createSubscriptions = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }

            setLoadingState(true);
            let isError = false;
            const errorMessage = {};
            setHasError({});
            setAddMessage('');
            if (selectedCategory.length === 0) {
                errorMessage.notification = { error: true, message: 'Please select a notification from the dropdown' };
                isError = true;
            } else {
                if (selectedAccount.length === 0) {
                    errorMessage.account = { error: true, message: 'Please select a billing account' };
                    isError = true;
                }
                if (_.isEmpty(selectedChannelType)) {
                    // updatePageError(AUTH_ERRORS.fieldIncorrect);
                    errorMessage.channel = { error: true, message: 'ChannelType - Please select either Email or Phone/SMS' };
                    isError = true;
                }
                if (!_.isUndefined(subscriptionForm.channelType) && subscriptionForm.channelType === 'EMAIL') {
                    const email = _.get(subscriptionForm, 'email');
                    if (isEmpty(email) || !checkEmailValidity(email)) {
                        // updatePageError(AUTH_ERRORS.fieldIncorrect);

                        errorMessage.email = { error: true, message: 'Email Error - not valid' };
                        isError = true;
                    }
                } else if (!_.isUndefined(subscriptionForm.channelType) && subscriptionForm.channelType === 'SMS') {
                    const phone = _.get(subscriptionForm, 'phone');
                    if (isEmpty(phone) || !checkPhoneValidity(phone)) {
                        errorMessage.phone = { error: true, message: 'Phone Number Error - not valid' };
                        isError = true;
                    }
                }
            }
            if (isError) {
                setHasError(errorMessage);
                setLoadingState(false);
                return Promise.resolve();
            }

            // const notificationPromise = ;
            return NotificationService.createBCSubscription(createSubscriptionMapper(), authHeader)
                .then((responseData) => {
                    
                    const message = _.get(responseData, 'message');

                    if (!_.isUndefined(message)) {
                        setAddMessage(message);
                    } else {
                        setAddMessage('');
                        setHasError({});
                        setShowAddNotification(false);
                        setSelectedChannelType('');
                        setSelectedAccount([]);
                        setSelectedCategory('');
                        setSelectedSubscription({});
                        setLoadingState(false);
                        setRefreshList(refreshList + 1);
                    }
                })
                .catch(() => {
                    setAddMessage('Cannot add notification, try again later.');
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [authHeader, hasError, subscriptionForm, selectedAccount, selectedCategory, selectedChannelType]
    );
    
    const handleCancel = useCallback(
        () => {
            setShowAddNotification(false);
            setSelectedChannelType('');
            setSelectedAccount(initSelectedAccount); // FB 17882
            setSelectedCategory('');
            setSelectedSubscription({});
            setAddMessage('');
        },
        [authHeader,initSelectedAccount]
    );

    const newSubscriptionTemplate = () => {
        const createSubscriptionMsg = {
            channel: {
                channelType: '', /* EMAIL, SMS */
                channelValue: ''
            },
            metadata: {
                accountNumber: [
                    ''
                ],
                name: '',
                company: 'Republic',
                riUser: '' /* Current User logged in : subscriptionForm.createdBy*/
            },
            ownerId: 'account_#', /* # = latest BID or Policy# for Republic */
            subscriptionId: '' /* key value for subscription */
        };
        return createSubscriptionMsg;
    };

    const createSubscriptionMapper = () => {
        console.log(`createSubscriptionMapper 01`);
        let channelDerivedValue = '';
        
        if (subscriptionForm.channelType === 'EMAIL') {
            channelDerivedValue = subscriptionForm.email;
        } else if (subscriptionForm.channelType === 'SMS') {
            // set SMS to +1########## format.
            channelDerivedValue = `+1${subscriptionForm.phone.replace(/[^\d]/g, '')}`;
        }
        const accountId = `account_${billingNumber}`;
        const createSubscriptionMsg = {
            channel: {
                channelType: subscriptionForm.channelType,
                channelValue: channelDerivedValue
            },
            metadata: {
                accountNumber: selectedAccount,
                name: subscriptionForm.name,
                company: 'Republic',
                riUser: getUserName()
            },
            ownerId: accountId,
            subscriptionId: subscriptionForm.notificationType
        };console.log(`createSubscriptionMsg = ${JSON.stringify(createSubscriptionMsg)}`);
        
        return createSubscriptionMsg;
    };

    const updateSelectedSubscription = (subscriptionId) => {
        
        subscriptions.forEach((sub) => {
            
            if (sub.subscriptionId === subscriptionId) {
                
                setSelectedSubscription(sub);
                const channelSelect = [];
                sub.channels.forEach((channel) => {
                    channelSelect.push(
                        {
                            code: channel.channelType,
                            name: channel.channelType
                        }
                    );
                    subscriptionForm.name = sub.name;
                    setChannelTypeValues(channelSelect);
                    
                    if (sub.channels.length === 1) {
                        handleChannelValueChange(sub.channels[0].channelType);
                    }
                });
            }
        });
    };

    const handleFilterValueChange = (value) => {        
        subscriptionForm.notificationType = value;
        setSelectedCategory(value);
        updateSelectedSubscription(value);
        setShowAddNotification(true);
    };

    const handleAdd = () => {
        setShowAddNotification(true);
    };

    const messageClosedFn = useCallback(() => {        
        setAddMessage('');
    }, [addMessage]);

    const handleChannelValueChange = (value) => {
        subscriptionForm.channelType = value;
        setSelectedChannelType(value);        
    };

    const handleAccountFn = useCallback((value) => {
        setSelectedAccount(value);
    }, []);

    const validateFn = useCallback((field, value) => {
        let isValid = true;
        if (field === 'email') {
            if (isEmpty(value) || !checkEmailValidity(value)) {
                setHasError({ email: { error: true, message: 'Email Error - not valid' } });
                isValid = false;                
            } else {
                setHasError({ email: {} });
            }
        }
        return isValid;
    }, [hasError]);

    const readValue = useCallback(
        (id, path) => {
            return _.get(subscriptionForm, path);
        },
        [subscriptionForm, translator]
    );

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(subscriptionForm);
            _.set(nextFormData, path, value);

            setSubscriptionForm(nextFormData);
        },
        [subscriptionForm]
    );
    
    // FB 21479 ---------------------------------------------------------------------------------
    const editStart = useCallback(row => {       
        window.existingChannelType = row.channelType;
        window.existingEmail = row.email;    
        window.notificationType = row.notificationType;            
        SetIsEditing(true);                  
        setTimeout(setupDropdownForChannelTypes, 100);        
    });

    const setupDropdownForChannelTypes = () => {
        
        const options = window.notificationType === 'Audit Statement' ? ["Email", "Mail"] : ["Email", "ePayroll", "Mail"];
        const inputList = document.querySelectorAll('[name^="channelTypeColumn"]'); 

        for (let i = 0; i < inputList.length; i++) {
            const input = inputList[i];
            const currentValue = input.value;
            
            // Create a new <select> element
            const select = document.createElement("select");
            select.id = "channelTypeSelect_" + i;

            select.onchange = function () {            
                setchannelTypeSelectValue(this.value); // using function (), "this" is bound to select  
            };

            // Add options and match current value
            options.forEach(value => {
                const option = document.createElement("option");
                option.value = value;
                option.textContent = value;

                if (value === currentValue) {
                    option.selected = true;
                    setchannelTypeSelectValue(value);
                }

                select.appendChild(option);
            });

            // Replace <input> with <select>
            input.parentNode.replaceChild(select, input);    
        } 

        function setchannelTypeSelectValue(value) {
            // Example: store in a global variable or update a state
            window.channelTypeSelectValue = value;            
        };
        
    };

    const editCancel = useCallback((row) => {
       
        const originalData = [...pcSubscriptionsSave];                         
        setPcSubscriptions(originalData);   

        setTimeout(() => {
            const editPenArray = Array.from(document.querySelectorAll('.gw-edit'));  
            // Enable all pen buttons          
            editPenArray.forEach(pen => pen.style.display = '');
        }, 100); // adjust delay as needed

        SetIsEditing(false); 
        SetIsValidEmail(true);
    });    

    // Called after click the Save button.
    const saveDataRow = useCallback(
        (newRow, index) => {  
            
            let isChannelTypeChanged = window.channelTypeSelectValue !== window.existingChannelType;
            if(isChannelTypeChanged){
                newRow.channelType = window.channelTypeSelectValue;
            }
                                      
            newRow.createdBy = getUserName();
            
            let isEmailValid = validateEmailAddress();
            SetIsValidEmail(isEmailValid);
            let isEmailChanged = newRow.email !== window.existingEmail;
 
            const newData = [...pcSubscriptions];
            newData.splice(index, 1, newRow);            
            setPcSubscriptions(newData);  

            if(isEmailValid){
                if(isEmailChanged || isChannelTypeChanged){
                    // Call API to update with the newRow
                    setPcSubscriptionObj(newRow);  
                }   
                SetIsEditing(false);   
            }

            // Inner function to handle the invalid email input field
            function validateEmailAddress() {
                let isEmailValid = true;
                
                if (!checkEmailValidity(newRow.email)) {
                    isEmailValid = false;
                    
                    // Keep the input email field open and show the error 
                    setTimeout(() => {
                        const editPenArray = Array.from(document.querySelectorAll('.gw-edit'));
                        for (let i = 0; i < editPenArray.length; i++) {

                            if (i === index) {
                                // Click the edit pen to keep the current row open for editing                
                                findParentButton(editPenArray[i]).click();
                                
                                setTimeout(() => {
                                    const inputs = Array.from(document.querySelectorAll('[name^="emailColumn"]'));
                                    // There should be only one email filed
                                    inputs.forEach(email => {
                                        email.style.color = 'red';
                                        email.style.borderColor = 'red';    
                                        email.focus();       
                                        email.onkeydown = () => {     
                                            email.style.color = '';  // when using () =>, "this.style.color " is not bound to email
                                            email.style.borderColor = '';    
                                        };                                                            
                                    });

                                }, 100);
                                
                            }else{
                                // Hide the none current row's edit pen
                                editPenArray[i].style.display = 'none';
                            }
                        }
                    }, 100); 
                }               
                return isEmailValid;
            }

            function findParentButton(elem) {
                if (!elem) return null;
                if (elem.tagName === "BUTTON") return elem;
                return findParentButton(elem.parentNode);
            }
        },
        [pcSubscriptions]
    );
    // FB 22743  ------
    const getPCNotificationTitle = () => {

        return (
            <>            
                <div className={styles.riTypeWithLOB}>
                    <span>
                        <h2>Premium Audit Paperless Options</h2>
                    </span>
                    <div className={styles.tooltip_container}>
                        <span>                   
                            <IconButton
                                icon="mi-help"
                                id="IconButton"
                            />                    
                        </span>
                        <div className={styles.tooltip_text}>
                            <p><b>Select your preferred method (channel) for receiving and submitting your payroll report:</b></p>
                            <ul>
                            <li><b>ePayroll</b> - When it is time to report, you will receive an email with a hyperlink to login to ePayroll for reporting.</li>
                            <li><b>Email</b> - When it is time to report, you will receive an email with a pdf copy of the payroll report for reporting. </li>
                            <li><b>Mail</b> - When it is time to report, you will receive a copy of the payroll report form to the address on file.</li>
                            </ul>
                            <div className={styles.tooltip_arrow}></div>
                        </div>
                    </div>
                </div>
            </>
        );
    };
    //---------------------------------------------------------------------------------- FB 21479

    const overrides = {
        '@field': {
            onValueChange: writeValue
        },
        notificationlistcomponent: {
            notifications: notifications
        },

        desciptionText: {
            content: selectedSubscription.description
        },
        channelType: {
            availableValues: channelTypeValues,
            showErrors: _.isEmpty(hasError.channel) ? false : hasError.channel.error,
            validationMessages: _.isEmpty(hasError.channel) ? [] : [hasError.channel.message],
            value: selectedChannelType

        },
        formCategory: {
            availableValues: categoryValues,
            value: selectedCategory,
            showErrors: _.isEmpty(hasError.notification) ? false : hasError.notification.error,
            validationMessages: _.isEmpty(hasError.notification) ? [] : [hasError.notification.message]
        },
        addNotificationsContainer: {
            visible: showAddNotification
        },
        addNotificationDetails: {
            visible: !(selectedCategory === '')
        },
        email: {
            visible: selectedChannelType === 'EMAIL',
            showErrors: _.isEmpty(hasError.email) ? false : hasError.email.error,
            validationMessages: _.isEmpty(hasError.email) ? [] : [hasError.email.message]
        },
        phone: {
            visible: selectedChannelType === 'SMS'
        },
        notificationList: {
            billingId: billingNumber,
            refresh: refreshList,
            showAddNotification: showAddNotification,
            isEditing: isEditing
        },
        pcNotificationTable: {
            data: Array.isArray(pcSubscriptions) && pcSubscriptions.length > 0
                ? pcSubscriptions
                : [{ policyNumber: 'SAMPLE123', notificationType: 'SampleType' }],
            refresh: refreshList,
            visible: !isLoading      
        },
        pcNotificationsContainer:{
            visible: !showAddNotification && !isLoading
        },
        toplevelmessage: {
            visible: false,
            type: 'error'
        },
        pcNotificationError:{
            visible: !isValidEmail,
            type: 'error'
        },
        addlevelmessage: {
            visible: !_.isEmpty(addMessage),
            type: 'error',
            message: addMessage
        },
        accountNumber: {
            availableValues: BillingAccountValues,
            value: selectedAccount,
            showErrors: _.isEmpty(hasError.account) ? false : hasError.account.error,
            validationMessages: _.isEmpty(hasError.account) ? [] : [hasError.account.message],
            onValueChange: (value) => handleAccountFn(value),
            visible: false // FB 18587 Hide billing account number
        },
        openModalAction: {
            visible: true
        },
        pcNotificationTitle: {
            content: getPCNotificationTitle()
        }        
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleFilterValueChange,
            handleChannelValueChange,
            createSubscriptions,
            handleCancel,
            handleAdd,
            messageClosedFn,
            handleAccountFn,
            editStart,
            editCancel,
            saveDataRow,
            getPCNotificationTitle
        },
        resolveComponentMap: {
            notificationlistcomponent: NotificationList
        }
    };

    //return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

export default withRouter(MyNotifications);
